import React from 'react';

interface ServiceCard {
  id: number;
  image: string;
  title: string;
  link: string;
}

const ServiceSection: React.FC = () => {
  const services: ServiceCard[] = [
    {
      id: 1,
      image: '/assets/images/service-1.jpg',
      title: 'VIP Deal',
      link: '#menu'
    },
    {
      id: 2,
      image: '/assets/images/service-2.jpg',
      title: 'Seasonal Deals',
      link: '#menu'
    },
    {
      id: 3,
      image: '/assets/images/service-3.jpg',
      title: 'Lunch Deal',
      link: '#menu'
    }
  ];

  return (
    <section
      id="best-iron-stew-pot"
      className="section service bg-black-10 text-center"
      aria-label="service"
    >
      <div className="container">
        <p className="section-subtitle label-2">Best Iron-Stew Pot in Los Angeles</p>

        <h2 className="headline-1 section-title">Authentic Northeastern Chinese Cuisine</h2>

        <p className="section-text">
          Experience the finest iron-stew pot dishes in Hacienda Heights. Our traditional northeastern 
          Chinese cuisine features premium ingredients and authentic cooking methods that have made us 
          the top choice in the 626 area.
        </p>

        <ul className="grid-list">
          {services.map((service) => (
            <li key={service.id}>
              <div className="service-card">
                <a href={service.link} className="has-before hover:shine">
                  <figure className="card-banner img-holder" style={{ width: '285px', height: '336px' }}>
                    <img
                      src={service.image}
                      width="285"
                      height="336"
                      loading="lazy"
                      alt={service.title}
                      className="img-cover"
                    />
                  </figure>
                </a>

                <div className="card-content">
                  <h3 className="title-4 card-title">
                    <a href={service.link}>{service.title}</a>
                  </h3>

                  <a href={service.link} className="btn-text hover-underline label-2">
                    View Menu
                  </a>
                </div>
              </div>
            </li>
          ))}
        </ul>

        <img
          src="/assets/images/shape-1.png"
          width="246"
          height="412"
          loading="lazy"
          alt="shape"
          className="shape shape-1 move-anim"
        />
        <img
          src="/assets/images/shape-2.png"
          width="343"
          height="345"
          loading="lazy"
          alt="shape"
          className="shape shape-2 move-anim"
        />
      </div>
    </section>
  );
};

export default ServiceSection;
